// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty_root__-E1C4"};